import React from "react";

const TipsComma = ({ row }) => {
  return <div>{row?.tips?.toLocaleString()}</div>;
};

export default TipsComma;
